import XTbl,{Xtc} from '../../../components/x-table/index';
const tbl = new XTbl('/report/task/', 'task matter');

tbl.add(new Xtc('assign_user', 'User').renderSlot('user').noSort())
tbl.add(new Xtc('upcoming', 'Upcoming').noSort().renderSlot('upcoming'))
tbl.add(new Xtc('overdue', 'Overdue').noSort().renderSlot('overdue'))
tbl.add(new Xtc('complete', 'Completed').noSort().renderSlot('complete'))

export default tbl;

